/* unplugin-vue-components disabled */import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-theme"];
import SvgSymbols from '@/components/common/SvgSymbols';
import { useThemeStore } from '@/stores/theme';
export default {
  __name: 'App',
  setup(__props) {
    // import UserControlPanel from '@/components/UserControlPanel'
    const themeStore = useThemeStore();
    const {
      init: initTheme
    } = themeStore;
    const {
      theme
    } = storeToRefs(themeStore);

    // const route = useRoute()
    // const pathname = computed(() => window.location.pathname)
    const href = computed(() => window.location.search);
    onMounted(() => {
      initTheme();
      // @NOTE: Dispatch event for host app
      const appMountedEvent = new CustomEvent('configurator-app__mounted', {
        detail: {}
      });
      window.dispatchEvent(appMountedEvent);
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", {
        id: "configuratorApp",
        "data-theme": _unref(theme),
        class: "h-full relative"
      }, [_createVNode(_unref(SvgSymbols)), (_openBlock(), _createBlock(_component_router_view, {
        key: _unref(href)
      }))], 8, _hoisted_1);
    };
  }
};